import { useState } from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { FaPencilAlt } from 'react-icons/fa'
import { useDispatch } from "react-redux";
import instanceOfAxios from "../../../../app/axios/axios";
import { show } from '../../Alerter/alerterSlice';
import Spinner from '../../../spinner/Spinner.jsx'
import { FaRegSave } from 'react-icons/fa';

export default function EditOrCreateCleaning(props) {
    const [visibility, setVisibility] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [params, setParams] = useState({ taxe_type_id: props.taxe_type_id });
    const [errors, setErrors] = useState([]);
    const dispatch = useDispatch();

    function handleChange(event) {
        params[event.target.name] = event.target.value;
        setParams(params);
    }

    function handleSave() {
        setIsSubmit(true);
        let functionName = 'post';
        let path = `admin/agency/${props.agency}/cleaning`
        if (props.for == 'edit') {
            path = `admin/agency/${props.agency}/cleaning/${props.cleaning.id}`;
            functionName = 'patch'
        }
        let paramsToSend = Object.assign({}, params);

        if(paramsToSend.type){
            paramsToSend.type = `T${params.type}`;
        }

        instanceOfAxios[functionName](path, paramsToSend)
            .then(res => {
                setVisibility(false);
                props.handleChange(true);
                dispatch(show({ message: 'Tarif mis à jour', variant: 'success' }));
                setIsSubmit(false);
            })
            .catch(error => {
                dispatch(show({ message: 'Erreur lors de la mise à jour', variant: 'danger' }));
                setIsSubmit(false);
                setErrors(Object.assign([], error.response.data.error));
            })
    }

    return (
        <>
            {props.for == 'edit' ?
                <Button size="md" className='goldenHover' style={{ marginLeft: "10px", marginBottom: "5px" }} onClick={() => setVisibility(!visibility)}>
                    <FaPencilAlt/>
                </Button>
                :
                <Button size="md" variant="secondary" style={{ marginLeft: "10px", marginBottom: "5px" }} onClick={() => setVisibility(!visibility)}>
                    Ajouter un Tarif
                </Button>
            }
            <Modal
                show={visibility}
                onHide={() => setVisibility(false)}
                scrollable
                backdropClassName="backdropFifth"
                backdrop="static"
                centered
                style={{ zIndex: '20004' }}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.for ? 'Ménage pour type' : 'Création d\'un tarif'} {props.cleaning && props.cleaning.type}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Nombre de pièce du bien *</Form.Label><br/>
                        {errors["type"] && <small style={{color: 'red'}}>{errors["type"][0]}</small>}
                        <Form.Control name="type" type="number" defaultValue={props.cleaning && props.cleaning.type.replace('T', '')} placeholder="2" onChange={(e) => handleChange(e)} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Minimum de personnes</Form.Label><br/>
                        {errors["min_person"] && <small style={{color: 'red'}}>{errors["min_person"][0]}</small>}
                        <Form.Control type="text" defaultValue={props.cleaning && props.cleaning.min_person} name="min_person" placeholder="2" onChange={(e) => handleChange(e)} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Maximum de personnes</Form.Label><br/>
                        {errors['max_person'] && <small style={{color: 'red'}}>{errors['max_person'][0]}</small>}
                        <Form.Control type="text" defaultValue={props.cleaning && props.cleaning.max_person} name="max_person" placeholder="8" onChange={(e) => handleChange(e)} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Valeur mini pour nombre mini de personnes</Form.Label><br/>
                        {errors['min_person_inf_value'] && <small style={{color: 'red'}}>{errors['min_person_inf_value'][0]}</small>}
                        <InputGroup>
                            <Form.Control type="text" defaultValue={props.cleaning && props.cleaning.min_person_inf_value} name="min_person_inf_value" placeholder="200" onChange={(e) => handleChange(e)} />
                            <InputGroup.Text>€</InputGroup.Text>
                        </InputGroup>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Valeur maxi pour nombre mini de personnes</Form.Label><br/>
                        {errors['min_person_sup_value'] && <small style={{color: 'red'}}>{errors['min_person_sup_value'][0]}</small>}
                        <InputGroup>
                            <Form.Control type="text" defaultValue={props.cleaning && props.cleaning.min_person_sup_value} name="min_person_sup_value" placeholder="200" onChange={(e) => handleChange(e)} />
                            <InputGroup.Text>€</InputGroup.Text>
                        </InputGroup>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Valeur mini pour nombre maxi de personnes</Form.Label><br/>
                        {errors['max_person_inf_value'] && <small style={{color: 'red'}}>{errors['max_person_inf_value'][0]}</small>}
                        <InputGroup>
                            <Form.Control type="text" defaultValue={props.cleaning && props.cleaning.max_person_inf_value} name="max_person_inf_value" placeholder="200" onChange={(e) => handleChange(e)} />
                            <InputGroup.Text>€</InputGroup.Text>
                        </InputGroup>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Valeur maxi pour nombre maxi de personnes</Form.Label><br/>
                        {errors['max_person_sup_value'] && <small style={{color: 'red'}}>{errors['max_person_sup_value'][0]}</small>}
                        <InputGroup>
                            <Form.Control type="text" defaultValue={props.cleaning && props.cleaning.max_person_sup_value} name="max_person_sup_value" placeholder="200" onChange={(e) => handleChange(e)} />
                            <InputGroup.Text>€</InputGroup.Text>
                        </InputGroup>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    {
                        isSubmit ?
                            <Spinner />
                            :
                            <>
                                <Button variant="danger" onClick={() => setVisibility(!visibility)}>
                                    Fermer
                                </Button>
                                <Button 
                                    className='whiteSVG'
                                    variant="secondary" 
                                    onClick={handleSave}>
                                    <FaRegSave/> Enregistrer
                                </Button>
                            </>
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}